import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { FileSpreadsheet } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Phase G — One-click Excel export button.
 *
 * Usage:
 *   <ExportToExcelButton path="invoices" />
 *   <ExportToExcelButton path="ar-aging" label="AR Aging" filename="ar-aging.xlsx" />
 */
export default function ExportToExcelButton({ path, label, filename, params = {}, className = "", size = "sm", variant = "outline" }) {
  const [busy, setBusy] = useState(false);
  const url = `${API}/exports/${path}.xlsx`;
  const buttonLabel = label || `Export ${path.replace("-", " ")}`;
  const downloadName = filename || `${path}.xlsx`;

  const download = async () => {
    setBusy(true);
    try {
      const res = await axios.get(url, { params, responseType: "blob" });
      const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = downloadName;
      link.click();
      URL.revokeObjectURL(link.href);
      toast.success(`${downloadName} downloaded`);
    } catch (e) {
      toast.error(e?.response?.status === 403 ? "Admin access required" : "Excel export failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button onClick={download} disabled={busy} size={size} variant={variant} className={className} data-testid={`export-excel-${path}`}>
      <FileSpreadsheet className="h-4 w-4 mr-1" />
      {busy ? "Exporting…" : buttonLabel}
    </Button>
  );
}
